import { TaskType } from '../types/domain';
import { computeProgress, formatProgress } from './number';
/** taskId(string) → TaskInfoVO；记录侧 taskId 为 number，统一按 String 匹配 */
export function buildTaskMap(taskInfos) {
    return new Map((taskInfos ?? []).map(t => [String(t.taskId), t]));
}
/** 助力记录标题：助力任务/未匹配 → followerName||'助力成功'；浏览/下单等其他任务 → 任务名称 */
export function resolveAssistRecordTitle(item, taskMap) {
    const task = item.taskId != null ? taskMap.get(String(item.taskId)) : undefined;
    if (task && task.taskType !== TaskType.INVITE_TASK) {
        return item.taskName || task.taskTitle || '助力成功';
    }
    return item.followerName || '助力成功';
}
/** 助力记录进度百分比：point/upperLimit，与主进度同规范（computeProgress + formatProgress） */
export function resolveAssistRecordProgress(item, upperLimit) {
    const point = item.assistValueDouble ?? item.assistValue ?? 0;
    return formatProgress(computeProgress(point, upperLimit));
}
/**
 * 从 UserRewardItem.extra（JSON字符串）中解析出 FreeOrderCardExtra
 */
export function parseFreeOrderCardExtra(item) {
    try {
        if (!item?.extra)
            return null;
        const parsed = JSON.parse(item.extra);
        return parsed?.freeOrderCardExtra ?? null;
    }
    catch {
        return null;
    }
}
